export const convertPayloadToFormData = (payload, isCreate = false) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value == null) return;

    if (key === "FileData") {
      value?.forEach((f) => {
        if (f?.File instanceof File) {
          formData.append("Data.FileData", f.File);
          isCreate && formData.append("Data.DocumentTypeID", f.DocumentTypeID);
        }
      });
    } else if (Array.isArray(value)) {
      value.forEach((v) => formData.append(`Data.${key}`, v));
    } else {
      formData.append(`Data.${key}`, value);
    }
  });

  return formData;
};
